import { ACL_SECTION, Acl$, ROLE } from "./acl$"
import { CoordinatorService } from "./coordinator.service"




export class Acl {
    private _permMap = new Map<string, number>()


    constructor(public coords: CoordinatorService, public id: ACL_SECTION) {

    }

    set(tag: string, value: number) {
        this._permMap.set(tag, value)
    }

    isOn(tag: string, role: number) {
        return (this._permMap.get(tag) || 0) <= role
    }

}
